import React,{useState} from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "../../../Components/Button";
import TableProductCard from "../../../Components/SkeletonCards/TableProductCard";
import TableProduct from "../../../Components/TableProduct";
import {Modal , Form , Row , Col} from 'antd'
import { Elements, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';

export default function Form3({
  handleChangeForm,
  data,
  isLoading,
  refetch,
  isFetching,
  handlePlaceOrder,
  paywithpaystack,
  orderLoading,
}) {

  const stripe = useStripe();
  const elements = useElements();

  const [opens, setOpens] = useState(false);

  const elementStyles = {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4"
      },
      border: "5px solid black",
      padding: "10px",
      borderRadius: "4px"
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a"
    }
  };

  const elementOptions = {
    style: elementStyles,
  };
  
  return (
    <div className="tab" style={{ display: "block" }}>
      <div className="table-responsive">
        <table className="table mt-5 tableCheckout">
          <thead className="thead-purple">
            <tr>
              <th scope="col" className="br-left">
                IMAGE
              </th>
              <th scope="col">PRODUCT</th>
              <th scope="col">QUANTITY</th>
              <th scope="col">UNIT PRICE</th>
              <th scope="col">TOTAL PRICE</th>
              <th scope="col">TAX</th>
              <th scope="col" className="br-right">
                {isFetching ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  <Link to="#" onClick={() => refetch()}>
                    <i className="fas fa-sync fc-white" />
                  </Link>
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr class="odd">
                <td valign="top" colspan="5" className="dataTables_empty">
                  <TableProductCard />
                </td>
              </tr>
            ) : (
              data?.map((item) => (
                <TableProduct disable_controls={true} item={item} />
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="form-row">
        {!orderLoading && (
          <button
            type="button"
            className="btn-lgray mt-30 m-1"
            onClick={() => handleChangeForm(1)}
          >
            BACK
          </button>
        )}
        <Button
          className="btn-orange mt-30 m-1"
          onClick={(e) => {

            setOpens(true)


            



          }}
          loading={orderLoading}
        >
          CONTINUE
        </Button>
        <Modal 
          open={opens} 
          onCancel={() => setOpens(false)}
          onOk={(e) => {
            Swal.fire({
              icon: "question",
              title: "SYSTEM MESSAGE",
              text: "Are you sure you want to Confirm this order?",
              confirmButtonText: "YES",
              confirmButtonColor: "#145B3D",
              showCancelButton: true,
              cancelButtonText: "NO",
              cancelButtonColor: "#0f1f2e",
            }).then((result) => {
              if (result.isConfirmed) {
                handlePlaceOrder(e);
                setOpens(false)
                
              }
            });
          } }
          >
          <div className="modal-content">
            <div className="modal-header">
             
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <Form
            layout="vertical"
            name="basic"
            initialValues={{
              remember: true,
            }}
          >


            <Row gutter={[16, 16]} className="for-gutter-0">
              <Col lg={24} xs={24}>
                <Form.Item
                  label="Card number"
                  name="Cardnumber"
                  rules={[
                    {
                      
                      required: true,
                      message: "Please input Card number!",
                    },
                  ]}
                >
                  {/* <Input
                    size="large"
                    placeholder="1234 1234 1234 1234"
                    className="web-input"
                    onChange={(e) => handleCardPaymentDetails('Cardnumber', e.target.value)}
                    value={card.Cardnumber }
                    maxLength={16}
                  /> */}

                  <CardNumberElement 
                    options={elementOptions} 
                   // onChange={(event) => handleChange('cardNumber', event)}
                    />
                </Form.Item>
              </Col>
              <Col lg={12} xs={24}>
                <Form.Item
                  label="Expiry date"
                  name="Expirydate"
                  rules={[
                    {
                      required: true,
                      message: "Please input Expiry date!",
                    },
                  ]}
                >
                  {/* <Input
                    size="large"
                    placeholder="MM/YY"
                    className="web-input"
                    onChange={(e) => handleCardPaymentDetails('Expirydate', e.target.value)}
                    value={card.Expirydate}
                  /> */}
                  <CardExpiryElement 
                    options={elementOptions}  
                   // onChange={(event) => handleChange('cardExpiry', event)}

                    />
                </Form.Item>
              </Col>
              <Col lg={12} xs={24}>
                <Form.Item
                  label="CVC"
                  name="cvc"
                  rules={[
                    {
                      required: true,
                      message: "Please input CVC!",
                    },
                  ]}
                >
                  {/* <Input
                    size="large"
                    placeholder="1234"
                    className="web-input"
                    onChange={(e) => handleCardPaymentDetails('CVC', e.target.value)}
                    value={card.CVC}
                    maxLength={3}
                  /> */}
                  <CardCvcElement 
                    options={elementOptions} 
                   // onChange={(event) => handleChange('cardCvc', event)}
                    />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          </div>
        </Modal>
      </div>
    </div>
  );
}
